/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsTabletBookingAppointmentOutput } from "../../entities/models/TabletBookingAppointmentOutput";
import { z } from "zod/v4";

export const modelsTabletBookingAppointmentOutputSchema = z.object({
    "appointment_id": z.optional(z.int()),
"barber_id": z.optional(z.int()),
"barber_name": z.optional(z.string()),
"barber_photo_url": z.optional(z.string()),
"display_name": z.optional(z.string()),
"emoji": z.optional(z.string()),
"group_role": z.optional(z.string()),
"number": z.optional(z.int()),
"price": z.optional(z.number()),
"scheduled_start_time": z.optional(z.string()),
"service_id": z.optional(z.int()),
"service_name": z.optional(z.string()),
"service_type": z.optional(z.string()),
"time": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsTabletBookingAppointmentOutput>